export default __webpack_public_path__ + "static/media/BG-Aquaguard.26b3d8ac.jpg";